import { registerSectionType } from "../../utils/sectionRegistry";
import { ImageTrackSection } from "../sectionComponents";

registerSectionType({
  type: "tarjetasImagen",
  label: "Cuadros con imagen",
  layout: "cards",
  previewBlocks: ["Tarjeta + imagen", "Tarjeta + imagen", "Tarjeta + imagen"],
  getDefaults: () => ({ type: "tarjetasImagen", title: "", backgroundImage: "", itemsText: "" }),
  editorFields: [
    { key: "backgroundImage", label: "Imagen de fondo", placeholder: "https://..." },
    { key: "linkUrl", label: "Enlace (URL)", placeholder: "https://... (opcional)" },
  ],
  itemLabel: "tarjeta",
  render: (section, index) => {
    const items = Array.isArray(section?.items) ? section.items : [];
    return <ImageTrackSection section={section} items={items} index={index} />;
  },
});
